

















import {
  defineComponent, ref, onMounted, onBeforeUnmount,
} from 'vue';

export default defineComponent({
  name: 'AutoCloseTooltip',
  props: {
    text: {
      type: String,
      default: '提示文本',
    },
    tooltipId: {
      type: String,
      default: 'default-tooltip',
    },
    useLocalStorage: {
      type: Boolean,
      default: true,
    },
    autoCloseDelay: {
      type: Number,
      default: 3000,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const isVisible = ref(true);
    let timer: number | null = null;

    const saveToLocalStorage = () => {
      if (props.useLocalStorage) {
        localStorage.setItem(`tooltip-${props.tooltipId}`, 'true');
      }
    };

    const closeTooltip = () => {
      saveToLocalStorage();
      isVisible.value = false;

      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }

      emit('close');
    };

    onMounted(() => {
      if (props.useLocalStorage) {
        const hasShown = localStorage.getItem(`tooltip-${props.tooltipId}`);
        if (hasShown) {
          isVisible.value = false;
          return;
        }
      }

      timer = window.setTimeout(() => {
        saveToLocalStorage();
        isVisible.value = false;
        emit('close');
      }, props.autoCloseDelay);
    });

    onBeforeUnmount(() => {
      if (timer !== null) {
        clearTimeout(timer);
      }
    });

    return {
      isVisible,
      closeTooltip,
    };
  },
});
